module.exports = __webpack_public_path__ + "3b5efef64ff9ebac7ecb9cae58be4a18.pdf";